import { NodeResizer } from 'reactflow';
import { StickyNote } from 'lucide-react';

export function CommentNode({ data, selected }: { data: { text?: string }; selected?: boolean }) {
  const text = (data.text ?? '').trim();

  return (
    <div className="h-full w-full min-h-[80px] min-w-[160px] rounded-xl border border-warning/30 bg-warning/10 px-3 py-2 text-sm">
      <NodeResizer isVisible={selected} minWidth={160} minHeight={80} />
      <div className="mb-1 flex items-center gap-1.5 text-xs font-medium text-warning">
        <StickyNote className="h-3.5 w-3.5" />
        Comment
      </div>
      {text ? (
        <div className="whitespace-pre-wrap break-words text-xs text-foreground/80">{text}</div>
      ) : (
        <div className="text-xs italic text-muted-foreground">Click to add text…</div>
      )}
    </div>
  );
}
